module.exports = __webpack_public_path__ + "img/banner-2.b6f26367.jpg";